import React from 'react'
import Slider from '@material-ui/lab/Slider'
import {
  CalcTitular,
  CalcRow,
  CalcValue,
  CalcTotal,
  CalcTotalValue,
  CalcContainer,
  SliderContainer,
} from './calculadora-styles'

const calculateCashback = (amount, factor) => {
  return Math.round((amount * factor) / 100)
}

class Calculator extends React.Component {
  state = {
    value1: 1500,
    value2: 740,
    value3: 1000,
  }

  handleChange1 = (event, value) => {
    this.setState({ value1: value })
  }
  handleChange2 = (event, value) => {
    this.setState({ value2: value })
  }
  handleChange3 = (event, value) => {
    this.setState({ value3: value })
  }

  render() {
    const { value1, value2, value3 } = this.state
    const caclulatedCashback =
      calculateCashback(value1, 4) +
      calculateCashback(value2, 4) +
      calculateCashback(value3, 1)
    const totalCahsback = caclulatedCashback > 115 ? 115 : caclulatedCashback

    return (
      <CalcContainer>
        <CalcRow>
          <CalcTitular className="rosado">Clubes Pricesmart</CalcTitular>
          <CalcValue color="rosado" value={value1} />
          <SliderContainer>
            <Slider
              classes={{
                container: 'value1',
                thumb: 'thumb-button rosado',
                trackBefore: 'track-before rosado',
                trackAfter: 'track-after',
                track: 'track',
              }}
              value={value1}
              min={0}
              max={2000}
              step={10}
              onChange={this.handleChange1}
            />
          </SliderContainer>
        </CalcRow>

        <CalcRow>
          <CalcTitular className="morado">Compras en aeropost.com</CalcTitular>
          <CalcValue color="morado" value={value2} />
          <SliderContainer>
            <Slider
              classes={{
                container: 'value2',
                thumb: 'thumb-button morado',
                trackBefore: 'track-before morado',
                trackAfter: 'track-after',
                track: 'track',
              }}
              value={value2}
              min={0}
              max={2000}
              step={10}
              onChange={this.handleChange2}
            />
          </SliderContainer>
        </CalcRow>

        <CalcRow>
          <CalcTitular className="verde">
            Compras en otros comercios
          </CalcTitular>
          <CalcValue color="verde" value={value3} />
          <SliderContainer>
            <Slider
              classes={{
                container: 'value3',
                thumb: 'thumb-button verde',
                trackBefore: 'track-before verde',
                trackAfter: 'track-after',
                track: 'track',
              }}
              value={value3}
              min={0}
              max={2000}
              step={10}
              onChange={this.handleChange3}
            />
          </SliderContainer>
        </CalcRow>
        <CalcRow>
          <CalcTotal>
            <div>Total de PriceCash acumulado:</div>
            <CalcTotalValue>${totalCahsback}</CalcTotalValue>
          </CalcTotal>
        </CalcRow>
      </CalcContainer>
    )
  }
}

export default Calculator
